import { render, staticRenderFns } from "./EmailSendHistory.vue?vue&type=template&id=07ee25d8&"
import script from "./EmailSendHistory.vue?vue&type=script&lang=js&"
export * from "./EmailSendHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports